import React, { FunctionComponent, useEffect } from 'react';
import { store } from 'react-notifications-component';
import Alert from '@material-ui/lab/Alert';
type ReactNotificationTriggerProps = {
    isError: boolean;
    message: string;
    errorCode: number;
    setError: Function;
    notificationType: 'success' | 'info' | 'warning' | 'error' | undefined;
};

const ReactNotificationTrigger: FunctionComponent<ReactNotificationTriggerProps> = (props) => {
    const { message, setError, notificationType } = props;
    useEffect(() => {
        if (message) {
            store.addNotification({
                container: 'top-center',
                content: (
                    <div className="errorNotificationMessage">
                        <Alert onClose={() => {}} severity={notificationType}>
                            {message}
                        </Alert>
                    </div>
                ),

                dismiss: {
                    duration: 1000,
                    onScreen: false,
                    pauseOnHover: true,
                    click: true,
                },
            });
            setError({ error: {} });
        }
    }, [message, notificationType, setError]);
    return <></>;
};

export default ReactNotificationTrigger;
